/**
 * Coffee PDP Package Options + Grind HTML dropdown.
 * Delegated listeners on document: variant-selects is re-rendered after every change,
 * so nothing is bound to the dropdown itself. Picking a row sets the native <select>
 * value and fires `change`, which is what variant-selects / product-info listen to.
 */
(function () {
  if (window.__pdpOptionDropdown) return;
  window.__pdpOptionDropdown = true;

  function setOpen(dropdown, open) {
    dropdown.classList.toggle('is-open', open);
    var btn = dropdown.querySelector('.pdp-optdd__btn');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.pdp-optdd.is-open').forEach(function (dropdown) {
      if (dropdown !== except) setOpen(dropdown, false);
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.pdp-optdd__btn');
    if (btn) {
      var dropdown = btn.closest('.pdp-optdd');
      var willOpen = !dropdown.classList.contains('is-open');
      closeAll(dropdown);
      setOpen(dropdown, willOpen);
      return;
    }

    var item = event.target.closest('.pdp-optdd__item');
    if (item) {
      var wrap = item.closest('.product-form__input');
      var select = wrap && wrap.querySelector('select');
      var value = item.getAttribute('data-pdp-optdd-value');
      closeAll();
      if (select && value !== null && select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    closeAll();
  });

  document.addEventListener('keydown', function (event) {
    var dropdown = event.target.closest && event.target.closest('.pdp-optdd');
    if (event.key === 'Escape') {
      var open = document.querySelector('.pdp-optdd.is-open');
      closeAll();
      if (open) {
        var btn = open.querySelector('.pdp-optdd__btn');
        if (btn) btn.focus();
      }
      return;
    }
    if (!dropdown || !dropdown.classList.contains('is-open')) return;
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    var items = Array.prototype.slice.call(dropdown.querySelectorAll('.pdp-optdd__item'));
    if (!items.length) return;
    var index = items.indexOf(document.activeElement);
    index = event.key === 'ArrowDown' ? Math.min(index + 1, items.length - 1) : Math.max(index - 1, 0);
    items[index].focus();
    event.preventDefault();
  });
})();
